import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Container, List } from '@pella/sash-framework';
import { CTA, Image } from '../../../';

const TabContent = ({ content }) => {
	const [displayPanel, setDisplayPanel] = useState(0);

	const handleDisplayPanel = (panel) => {
		setDisplayPanel(panel);
	};

	return (
		<div
			className='py-10 md:py-20'
			style={{ backgroundColor: content.background_hex_value }}
		>
			<Container>
				<div className='grid grid-cols-1 items-center md:grid-cols-2'>
					{content.heading && (
						<h2
							dangerouslySetInnerHTML={{ __html: content.heading }}
							className={`col-start-1 row-start-1 m-0 pb-6 md:row-start-2 md:pb-5 xl:pb-6 ${content.layout_options === 'text right' ? 'md:col-start-2' : ''}`}
						/>
					)}
					{content.description && (
						<div
							dangerouslySetInnerHTML={{ __html: content.description }}
							className={`col-start-1 row-start-2 mb-6 text-sm md:row-start-3 md:mb-5 md:text-base xl:mb-6 xl:text-lg ${content.layout_options === 'text right' ? 'md:col-start-2' : ''}`}
						/>
					)}
					<div className={`col-start-1 row-start-3 flex h-[312px] flex-col items-center md:row-span-6 md:row-start-1 md:h-[344px] lg:h-[525px] ${content.layout_options === 'text right' ? '' : 'md:col-start-2'}`}>{content.content_sections?.[displayPanel]?.image?.[0] && <Image data={content.content_sections[displayPanel].image[0]} />}</div>
					{content.content_sections?.[0] && (
						<List
							bullets='none'
							className={`col-start-1 row-start-4 md:row-start-4 ${content.layout_options === 'text right' ? 'md:col-start-2' : ''}`}
						>
							{content.content_sections.map((sections, index) => (
								<li key={index}>
									<button
										onClick={() => handleDisplayPanel(index)}
										className={`mb-[18px] border-l-4 pl-6 text-left md:mb-5 ${displayPanel === index ? 'border-primary' : 'border-gray-15 py-2.5'} hover:opacity-70 ${displayPanel != index && 'hover:opacity-70'}`}
									>
										{sections.heading && <h3 dangerouslySetInnerHTML={{ __html: sections.heading }} />}
										{sections.description && index === displayPanel && (
											<div
												className='tracking-[0.5px]'
												dangerouslySetInnerHTML={{ __html: sections.description }}
											/>
										)}
									</button>
								</li>
							))}
						</List>
					)}
					{content.cta?.[0] && (
						<CTA
							data={content.cta[0]}
							className={`col-start-1 row-start-5 !justify-start md:row-start-5 ${content.layout_options === 'text right' ? 'md:col-start-2' : ''}`}
						/>
					)}
				</div>
			</Container>
		</div>
	);
};

TabContent.propTypes = {
	content: PropTypes.object,
};

export default TabContent;
